module.exports = __webpack_public_path__ + "img/supply.4d4a1938.png";